import { Button } from "../shared/button/button";
import { ContainerLogin } from "./styles";
import {
  LinkStyled,
  NormalText,
  TextFieldStyled,
  TitleStyled,
} from "../shared/styles";
import { Box } from "@mui/material";
import { useState } from "react";
import { Announcement } from "../shared/announcement/announcement";
import { useSelector } from "react-redux";
import { validateEmail } from "../shared/utils";
import { useDispatch } from "react-redux";
import { recoverPassword } from "../redux/actions/user.actions";
import { setRecoverPassword } from "../redux/reducers/user";

export const ForgotPassword = () => {
  const [email, setEmail] = useState({
    value: "",
    error: "",
  });

  const {
    success: successRecoverPassword,
    error: errorRecoverPassword,
    isLoading: isLoadingRecoverPassword,
  } = useSelector((state) => state.user.recoverPassword);

  const dispatch = useDispatch();

  function handleRecoverPassword(e) {
    setEmail({ value: e.target.value, error: "" });
    dispatch(
      setRecoverPassword({
        error: null,
        success: null,
        isLoading: false,
      })
    );
  }

  function handleSendEmail(e) {
    if (e?.type === "keydown" && e.key !== "Enter") {
      return;
    }

    if (!email.value) {
      setEmail((prev) => ({
        ...prev,
        error: "You have not entered any email address.",
      }));
      return;
    }

    if (!validateEmail(email.value)) {
      setEmail((prev) => ({
        ...prev,
        error:
          "Please enter a valid email address in the format: user@example.com",
      }));
      return;
    }

    setEmail((prev) => ({
      ...prev,
      error: "",
    }));
    dispatch(recoverPassword(email?.value));
  }

  return (
    <ContainerLogin>
      <Box margin={"0 auto"}>
        {/* <img
          src="/logo-develone-2.png"
          alt="Logo Develone"
          width={72}
        /> */}
        <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <TitleStyled>Forgot your password?</TitleStyled>
        <NormalText>
          Enter the email address you use to login to your account, we will be
          sending you an email so you can recover it.
        </NormalText>
      </Box>
      <TextFieldStyled
        name={"email"}
        placeholder={"Email"}
        type={"text"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        onChange={handleRecoverPassword}
        onKeyDown={handleSendEmail}
      />
      <Button
        label={"Recover password"}
        fullWidth
        onClick={handleSendEmail}
        buttonStyles={{
          padding: "12px",
          minHeight: "47px",
        }}
        isLoading={isLoadingRecoverPassword}
      />
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <LinkStyled href="/" underline="none">
          Back to login
        </LinkStyled>
      </Box>
      {successRecoverPassword && (
        <Announcement
          title={"Success"}
          description={
            successRecoverPassword || "Password recovered successfully"
          }
          type={"info"}
        />
      )}
      {(email?.error || errorRecoverPassword) && (
        <Announcement
          title={"Error"}
          description={email?.error || errorRecoverPassword}
          type={"error"}
        />
      )}
    </ContainerLogin>
  );
};
